import { render } from "./DateTimeDisplay.vue?vue&type=template&id=7b5ddaaa"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=js"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__